import type { CiaDependencies } from '~/composables/useCia/types';
import { RESET_PASSWORD } from '~~/constants/cia';

type CustomerResetPasswordRequest = {
  email: string;
  locale: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, languageAndCountry } = dependencies;

  return async (email: string): Promise<unknown> => {

    if (!email) {

      return Promise.resolve();
    
    }

    const payload: CustomerResetPasswordRequest = {
      email,
      locale: languageAndCountry,
    };

    return fetch(`/cia/${RESET_PASSWORD}`, {
      method: 'POST',
      body: payload,
    });
  
  };

};
